import AcceptOrRejectFileListAction from '@/modules/FileList/components/fileDetailCardActions/AcceptOrRejectFileListAction.tsx';
import EntryAndEditFileListAction from '@/modules/FileList/components/fileDetailCardActions/EntryAndEditFileListAction.tsx';
import { FileListActionPropsType } from '@/modules/FileList/components/fileDetailCardActions/FileListlAction.type.ts';
import FileListEntryAction from '@/common/components/DetailCard/actions/FileListEntryAction.tsx';
import OnlyAcceptFileListAction from '@/modules/FileList/components/fileDetailCardActions/onlyAcceptFileListAction.tsx';

const FileListDetailCardActions = ({
  action,
  id,
}: Pick<FileListActionPropsType['file'], 'id' | 'action'>) => {
  if (action === 'acceptOrReject') {
    return <AcceptOrRejectFileListAction fileId={id} />;
  }
  if (action === 'enter') {
    return <FileListEntryAction fileId={id} />;
  }
  if (action === 'enterAndEditTime') {
    return <EntryAndEditFileListAction />;
  }
  if (action === 'accept') {
    return <OnlyAcceptFileListAction fileId={id} />;
  }
};
export default FileListDetailCardActions;
